import { createFileRoute } from '@tanstack/react-router';
import { BudgetsPage } from '@/components/budgets/BudgetsPage';

export const Route = createFileRoute('/dashboard/budgets/')({
  component: BudgetsPage,
});
